<script lang="ts">import { browser } from "$app/environment";
import { cfgBrandTitle, cfgToThemeContentPath } from "@infinitro/config";
import { locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import { applyStaticSeoPlaceholders, fetchLocaleRawWithEnFallback, renderSeoMarkdown } from "./fetch-markdown-seo";
export let showMoreButton = true;
export let withBackground = false;
export let noContainer = false;
export let section;
const BRAND_NAME = cfgBrandTitle();
let htmlContent = "";
let lastModified = "";
// The link nav exists only in the build shell, never in the CDN markdown, so it is held
// separately and re-appended after the fetch below replaces the seeded copy.
let seededLinks = "";
// Seed from the hidden build-time SEO block for first paint / crawlers; always fetch below
// so a wrong-locale shell (e.g. EN block on Turboslots tr) can be replaced.
if (browser) {
	const copy = document.querySelector("#seo-static-block .markdown-seo");
	if (copy) {
		const nav = copy.querySelector(".seo-static__links");
		seededLinks = nav?.outerHTML ?? "";
		nav?.remove();
		htmlContent = copy.innerHTML + seededLinks;
		copy.remove();
	}
}
$: sec = section || "home";
$: loc = $locale;
// Keep seeded static HTML while loggedIn is unresolved; clear only when logged in.
$: if ($loggedIn === true) {
	htmlContent = "";
	lastModified = "";
} else if ($loggedIn === false && sec) {
	const localeUrl = cfgToThemeContentPath(`/seo/${sec}/${sec}.${loc}.md`);
	const enUrl = cfgToThemeContentPath(`/seo/${sec}/${sec}.en.md`);
	const capturedSec = sec;
	const capturedLoc = loc;
	fetchLocaleRawWithEnFallback(localeUrl, enUrl, { cacheBust: true }).then(({ raw, lastModified: lm }) => {
		if (capturedSec !== sec || capturedLoc !== $locale || $loggedIn !== false) return;
		const withPlaceholders = applyStaticSeoPlaceholders(raw, BRAND_NAME);
		htmlContent = renderSeoMarkdown(withPlaceholders) + seededLinks;
		lastModified = lm;
	});
}
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

<!-- `!== true`, not `=== false`: loggedIn resolves async and a crawler may snapshot first. -->
{#if $loggedIn !== true}
	<CdnSeoMarkdownPanel
		{htmlContent}
		{lastModified}
		{showMoreButton}
		{withBackground}
		{noContainer}
	/>
{/if}
